// Reexporta os ícones Feather (react-icons/fi) já convertidos para um tipo de
// componente aceito pelo JSX. O react-icons 5.x tipa cada ícone como retornando
// `ReactNode`, o que o TypeScript 5 (com React 19) não aceita diretamente como
// tag JSX — por isso o cast único aqui, em vez de repetir `as any` em cada uso.
import * as FiAll from 'react-icons/fi';
import type { IconBaseProps } from 'react-icons';

type FiIconComponent = React.FC<IconBaseProps>;
const cast = (icon: unknown) => icon as FiIconComponent;

export const FiPlus = cast(FiAll.FiPlus);
export const FiEdit2 = cast(FiAll.FiEdit2);
export const FiTrash2 = cast(FiAll.FiTrash2);
export const FiEye = cast(FiAll.FiEye);
export const FiExternalLink = cast(FiAll.FiExternalLink);
export const FiX = cast(FiAll.FiX);
export const FiXCircle = cast(FiAll.FiXCircle);
export const FiCheck = cast(FiAll.FiCheck);
export const FiSend = cast(FiAll.FiSend);
export const FiSlash = cast(FiAll.FiSlash);
export const FiArrowLeft = cast(FiAll.FiArrowLeft);
export const FiDownload = cast(FiAll.FiDownload);
export const FiUpload = cast(FiAll.FiUpload);
export const FiCopy = cast(FiAll.FiCopy);
export const FiLock = cast(FiAll.FiLock);
export const FiUnlock = cast(FiAll.FiUnlock);
export const FiPower = cast(FiAll.FiPower);
export const FiRotateCcw = cast(FiAll.FiRotateCcw);
export const FiSearch = cast(FiAll.FiSearch);
export const FiSave = cast(FiAll.FiSave);
export const FiRefreshCw = cast(FiAll.FiRefreshCw);
export const FiLogIn = cast(FiAll.FiLogIn);
export const FiLogOut = cast(FiAll.FiLogOut);
export const FiFilter = cast(FiAll.FiFilter);
export const FiPrinter = cast(FiAll.FiPrinter);
export const FiMail = cast(FiAll.FiMail);
export const FiUserPlus = cast(FiAll.FiUserPlus);
export const FiChevronLeft = cast(FiAll.FiChevronLeft);
export const FiChevronRight = cast(FiAll.FiChevronRight);
export const FiSun = cast(FiAll.FiSun);
export const FiMoon = cast(FiAll.FiMoon);
export const FiMenu = cast(FiAll.FiMenu);
export const FiPlay = cast(FiAll.FiPlay);
export const FiPaperclip = cast(FiAll.FiPaperclip);
export const FiLink = cast(FiAll.FiLink);
export const FiPlusCircle = cast(FiAll.FiPlusCircle);
export const FiAlertTriangle = cast(FiAll.FiAlertTriangle);
export const FiFileText = cast(FiAll.FiFileText);
export const FiClock = cast(FiAll.FiClock);
export const FiSettings = cast(FiAll.FiSettings);
export const FiChevronDown = cast(FiAll.FiChevronDown);
export const FiChevronUp = cast(FiAll.FiChevronUp);
export const FiCheckCircle = cast(FiAll.FiCheckCircle);
export const FiInfo = cast(FiAll.FiInfo);
export const FiBriefcase = cast(FiAll.FiBriefcase);
export const FiUsers = cast(FiAll.FiUsers);
export const FiCheckSquare = cast(FiAll.FiCheckSquare);
export const FiClipboard = cast(FiAll.FiClipboard);
export const FiUser = cast(FiAll.FiUser);
